import styled from '@emotion/styled';
import { Popover } from '@mui/material';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import tw from 'twin.macro';

import { getFormattedPhoneNumber } from '../../../helpers';
import { Icon, IconButton } from '../../Shared';

const StyledPopover = styled(Popover)`
  & .MuiPaper-root {
    ${tw`bg-white p-1 max-h-[140px] overflow-y-auto rounded-xl shadow-none w-[420px]`}
  }
`;

export const PhoneNumberSelector = ({
  phoneNumbers,
  phoneNumberToCall,
  setPhoneNumberToCall,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openPopover = event => {
    setAnchorEl(event.currentTarget);
  };

  const closePopover = () => {
    setAnchorEl(null);
  };

  const onChangePhoneNumberToCall = selectedPhoneNumberToCall => {
    setPhoneNumberToCall(selectedPhoneNumberToCall);
    closePopover();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const isPopoverAvailable = phoneNumbers.length > 1;

  return (
    <>
      <div className="flex justify-between items-center px-6 py-5 border-b border-b-base-200">
        <div className="flex flex-col gap-0.5">
          <span className="text-base-1000 font-medium text-[16px]/[24px]">
            You are dialing
          </span>
          <div className="flex items-center gap-2">
            <span className="text-brand-900 font-semibold text-[18px]/[24px]">
              {getFormattedPhoneNumber(phoneNumberToCall.PhoneNumber)}
            </span>
            {phoneNumberToCall.IsBestPhoneNumber && (
              <span className="text-white font-medium text-[14px]/[20px] bg-success-500 py-0.5 px-2 rounded-lg">
                Best number
              </span>
            )}
          </div>
        </div>
        {isPopoverAvailable && (
          <IconButton
            buttonProps={{
              className: 'w-8 h-8',
              onClick: openPopover,
            }}
            iconProps={{
              name: 'chevron',
              alt: 'chevron',
              className: twMerge('h-6', open && 'rotate-180'),
            }}
          />
        )}
      </div>
      <StyledPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={closePopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        {phoneNumbers.map(v => {
          const { PhoneNumber, IsBestPhoneNumber, ContactPhoneNumberId } = v;
          const isSelected =
            ContactPhoneNumberId === phoneNumberToCall.ContactPhoneNumberId;

          return (
            <button
              key={ContactPhoneNumberId}
              onClick={() => {
                onChangePhoneNumberToCall(v);
              }}
              className="w-full flex items-center justify-between px-3 py-2.5 rounded-lg hover:bg-[#EEF7FF] focus:bg-[#EEF7FF] outline-none"
            >
              <div className="flex items-center gap-2">
                <span className="text-brand-900 font-semibold text-[18px]/[24px]">
                  {getFormattedPhoneNumber(PhoneNumber)}
                </span>
                {IsBestPhoneNumber && (
                  <span className="text-white font-medium text-[14px]/[20px] bg-success-500 py-0.5 px-2 rounded-lg">
                    Best number
                  </span>
                )}
              </div>
              {isSelected && <Icon name="check" alt="check" className="h-4" />}
            </button>
          );
        })}
      </StyledPopover>
    </>
  );
};
